module.exports = __webpack_public_path__ + "static/img/header.5489c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/header.png
// module id = e81b
// module chunks = 0